module.exports = __webpack_public_path__ + "img/docs-icon.03ead3a9.svg";